<file-browser [entries]="files" *ngIf="files"
  (select)="select($event)"
  (upload)="upload($event)"
  (new)="new($event)"
  (edit)="edit($event)"
  (delete)="delete($event)"
></file-browser>
